import React from 'react';
import {
  AbsoluteFill,
  Audio,
  Sequence,
  interpolate,
  staticFile,
  useCurrentFrame,
} from 'remotion';
import {brand, brandFont} from '../brand';
import {BgGradient} from '../components/BgGradient';

export type HookReelProps = {
  hook: string;
  punchline: string;
  payoff: string;
};

const Beat: React.FC<{text: string; size: number; color?: string}> = ({
  text,
  size,
  color = brand.textPrimary,
}) => {
  const frame = useCurrentFrame();
  const opacity = interpolate(frame, [0, 8], [0, 1], {extrapolateRight: 'clamp'});
  const y = interpolate(frame, [0, 14], [40, 0], {extrapolateRight: 'clamp'});
  return (
    <AbsoluteFill style={{justifyContent: 'center', alignItems: 'center'}}>
      <div
        style={{
          fontFamily: brandFont,
          fontWeight: 800,
          color,
          fontSize: size,
          letterSpacing: -2,
          lineHeight: 1.05,
          textAlign: 'center',
          padding: '0 80px',
          opacity,
          transform: `translateY(${y}px)`,
        }}
      >
        {text}
      </div>
    </AbsoluteFill>
  );
};

export const HookReel: React.FC<HookReelProps> = ({hook, punchline, payoff}) => (
  <AbsoluteFill>
    <BgGradient />
    <Audio src={staticFile('music/hook-reel-2.mp3')} volume={0.4} />
    <Sequence  durationInFrames={70}>
      <Beat text={hook} size={120} />
    </Sequence>
    <Sequence from={70} durationInFrames={70}>
      <Beat text={punchline} size={130} />
    </Sequence>
    <Sequence from={140} durationInFrames={70}>
      <Beat text={payoff} size={150} color={brand.action} />
    </Sequence>
  </AbsoluteFill>
);
